import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetStatsEnvironment } from '../fleet-stats-environment';
import { customPlaceStatsSchema } from '../schemas/custom-place-stats.schema';

/**
 * Gets custom places stats
 * @returns Custom places stats
 */
export function getDashboardCustomPlacesStats(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetStatsEnvironment.resolve(this).dashboardCustomPlacesStatsUrl,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(customPlaceStatsSchema));
}
